<template>
  <div id="editUser" v-loading="isLoging">
    <el-dialog title="编辑用户信息" width="40%" top="2rem" :close-on-click-modal="false" :visible.sync="showDialog"
      :destroy-on-close="true" @close="close()">
      <div id="shared" style="margin-right: 20px;">
        <el-form ref="editForm" label-width="80px">
          <el-form-item label="用户名">
            <el-input v-model="username" disabled></el-input>
          </el-form-item>
          <el-form-item label="电话">
            <el-input v-model="phone" autocomplete="off" placeholder="请输入电话号码"></el-input>
          </el-form-item>
          <el-form-item label="地址">
            <el-input v-model="address" autocomplete="off" placeholder="请输入地址"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="remark" type="textarea" :rows="3" placeholder="请输入备注信息"></el-input>
          </el-form-item>

          <el-form-item>
            <div style="float: right;">
              <el-button type="primary" @click="onSubmit">保存</el-button>
              <el-button @click="close">取消</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "editUser",
  props: {},
  computed: {},
  data() {
    return {
      userId: null,
      username: null,
      phone: null,
      address: null,
      remark: null,
      listChangeCallback: null,
      showDialog: false,
      isLoging: false,
    };
  },
  methods: {
    openDialog: function (user, callback) {
      this.userId = user.id;
      this.username = user.username;
      this.phone = user.phone;
      this.address = user.address;
      this.remark = user.remark;
      this.listChangeCallback = callback;
      this.showDialog = true;
    },
    onSubmit: function () {
      this.$axios({
        method: 'post',
        url: "/api/user/update",
        params: {
          id: this.userId,
          phone: this.phone,
          address: this.address,
          remark: this.remark
        }
      }).then((res) => {
        if (res.data.code === 0) {
          this.$message({
            showClose: true,
            message: '修改成功',
            type: 'success',
          });
          this.showDialog = false;
          this.listChangeCallback()
        } else {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: 'error'
          });
        }
      }).catch((error) => {
        console.error(error)
      });
    },
    close: function () {
      this.showDialog = false;
      this.userId = null;
      this.username = null;
      this.phone = null;
      this.address = null;
      this.remark = null;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/dialog/editUser.vue